import React, { Component } from 'react';
import { Accordion, AccordionItem, AccordionItemHeading, AccordionItemButton, AccordionItemPanel } from 'react-accessible-accordion';
import HeaderSettings from './tripadvisor/HeaderSettings';
import LayoutSettings from './tripadvisor/LayoutSettings';
import ButtonSettings from './tripadvisor/ButtonSettings';
import ReviewsSettings from './tripadvisor/ReviewsSettings';
import ContainerSettings from './tripadvisor/ContainerSettings';
import ToggleSwitch from '../../Editor/fields/ToggleSwitch'; 
import InfoPopup from '../../Editor/InfoPopup'; 

class Tripadvisor extends Component {
    constructor(props) {
        super(props);

        const { widget } = this.props;
        const { htmlData } = widget;

        this.state = {
            widget: {
                htmlData: {
                    tripadvisor: {
                        url: decodeURIComponent(htmlData?.tripadvisor?.url || ''),
                        header: {
                            logoSize: htmlData?.tripadvisor?.header?.logoSize || '60px',
                            logoAlignment: htmlData?.tripadvisor?.header?.logoAlignment || 'left',
                            companyNameFontFamily: htmlData?.tripadvisor?.header?.companyNameFontFamily || 'Arial, sans-serif',
                            companyNameFontSize: htmlData?.tripadvisor?.header?.companyNameFontSize || '24px',
                            companyNameFontBold: htmlData?.tripadvisor?.header?.companyNameFontBold || 'bold',
                            companyNameColor: htmlData?.tripadvisor?.header?.companyNameColor || '#333333',
                            totalReviewsFontFamily: htmlData?.tripadvisor?.header?.totalReviewsFontFamily || 'Arial, sans-serif',
                            totalReviewsFontSize: htmlData?.tripadvisor?.header?.totalReviewsFontSize || '14px',
                            totalReviewsFontBold: htmlData?.tripadvisor?.header?.totalReviewsFontBold || 'normal',
                            totalReviewsColor: htmlData?.tripadvisor?.header?.totalReviewsColor || '#666666',
                            headerBackgroundColor: htmlData?.tripadvisor?.header?.headerBackgroundColor || '#ffffff',
                            headerBorderRadius: htmlData?.tripadvisor?.header?.headerBorderRadius || '8px',
                            ratingFontFamily: htmlData?.tripadvisor?.header?.ratingFontFamily || 'Arial, sans-serif',
                            ratingFontSize: htmlData?.tripadvisor?.header?.ratingFontSize || '16px',
                            ratingFontBold: htmlData?.tripadvisor?.header?.ratingFontBold || 'bold',
                            ratingColor: htmlData?.tripadvisor?.header?.ratingColor || '#00aa6c',
                            ratingCountColor: htmlData?.tripadvisor?.header?.ratingCountColor || '#666666',
                            ratingStarSize: htmlData?.tripadvisor?.header?.ratingStarSize || '20px',
                            ratingStarColor: htmlData?.tripadvisor?.header?.ratingStarColor || '#00aa6c',
                            ratingStarEmptyColor: htmlData?.tripadvisor?.header?.ratingStarEmptyColor || '#e5e5e5',
                            showHeader: htmlData?.tripadvisor?.header?.showHeader !== false,
                            showLogo: htmlData?.tripadvisor?.header?.showLogo !== false,
                            showCompanyName: htmlData?.tripadvisor?.header?.showCompanyName !== false,
                            showTotalReviews: htmlData?.tripadvisor?.header?.showTotalReviews !== false,
                            showRating: htmlData?.tripadvisor?.header?.showRating !== false,
                        },
                        layout: {
                            layoutType: htmlData?.tripadvisor?.layout?.layoutType || 'list',
                            columnGap: htmlData?.tripadvisor?.layout?.columnGap || '10px',
                        },
                        button: {
                            WriteReviewFontFamily: htmlData?.tripadvisor?.button?.WriteReviewFontFamily || 'Arial, sans-serif',
                            WriteReviewFontSize: htmlData?.tripadvisor?.button?.WriteReviewFontSize || '14px',
                            WriteReviewFontWeight: htmlData?.tripadvisor?.button?.WriteReviewFontWeight || 'normal',
                            WriteReviewAlignment: htmlData?.tripadvisor?.button?.WriteReviewAlignment || 'left',
                            WriteReviewColor: htmlData?.tripadvisor?.button?.WriteReviewColor || '#ffffff',
                            WriteReviewBackgroundColor: htmlData?.tripadvisor?.button?.WriteReviewBackgroundColor || '#00aa6c',
                            WriteReviewHoverTextColor: htmlData?.tripadvisor?.button?.WriteReviewHoverTextColor || '#ffffff',
                            WriteReviewHoverBackgroundColor: htmlData?.tripadvisor?.button?.WriteReviewHoverBackgroundColor || '#008055',
                            WriteReviewPadding: htmlData?.tripadvisor?.button?.WriteReviewPadding || '10px 20px',
                            WriteReviewBorderRadius: htmlData?.tripadvisor?.button?.WriteReviewBorderRadius || '4px',
                            showWriteReview: htmlData?.tripadvisor?.button?.showWriteReview !== false,
                        },
                        reviews: {
                            reviewerNameFontFamily: htmlData?.tripadvisor?.reviews?.reviewerNameFontFamily || 'Arial, sans-serif',
                            reviewerNameFontSize: htmlData?.tripadvisor?.reviews?.reviewerNameFontSize || '16px',
                            reviewerNameFontBold: htmlData?.tripadvisor?.reviews?.reviewerNameFontBold || 'bold',
                            reviewerNameColor: htmlData?.tripadvisor?.reviews?.reviewerNameColor || '#00aa6c',
                            reviewerDetailsFontFamily: htmlData?.tripadvisor?.reviews?.reviewerDetailsFontFamily || 'Arial, sans-serif',
                            reviewerDetailsFontSize: htmlData?.tripadvisor?.reviews?.reviewerDetailsFontSize || '12px',
                            reviewerDetailsColor: htmlData?.tripadvisor?.reviews?.reviewerDetailsColor || '#666666',
                            starColor: htmlData?.tripadvisor?.reviews?.starColor || '#00aa6c',
                            starEmptyColor: htmlData?.tripadvisor?.reviews?.starEmptyColor || '#cccccc',
                            starSize: htmlData?.tripadvisor?.reviews?.starSize || '26px',
                            reviewDateFontFamily: htmlData?.tripadvisor?.reviews?.reviewDateFontFamily || 'Arial, sans-serif',
                            reviewDateFontSize: htmlData?.tripadvisor?.reviews?.reviewDateFontSize || '12px',
                            reviewDateFontWeight: htmlData?.tripadvisor?.reviews?.reviewDateFontWeight || 'normal',
                            reviewDateColor: htmlData?.tripadvisor?.reviews?.reviewDateColor || '#666666',
                            reviewTitleFontFamily: htmlData?.tripadvisor?.reviews?.reviewTitleFontFamily || 'Arial, sans-serif',
                            reviewTitleFontSize: htmlData?.tripadvisor?.reviews?.reviewTitleFontSize || '16px',
                            reviewTitleFontBold: htmlData?.tripadvisor?.reviews?.reviewTitleFontBold || 'bold',
                            reviewTitleColor: htmlData?.tripadvisor?.reviews?.reviewTitleColor || '#333333',
                            reviewTextFontFamily: htmlData?.tripadvisor?.reviews?.reviewTextFontFamily || 'Arial, sans-serif',
                            reviewTextFontSize: htmlData?.tripadvisor?.reviews?.reviewTextFontSize || '14px',
                            reviewTextFontWeight: htmlData?.tripadvisor?.reviews?.reviewTextFontWeight || 'normal',
                            reviewTextColor: htmlData?.tripadvisor?.reviews?.reviewTextColor || '#333333',
                            readMoreFontFamily: htmlData?.tripadvisor?.reviews?.readMoreFontFamily || 'Arial, sans-serif',
                            readMoreFontSize: htmlData?.tripadvisor?.reviews?.readMoreFontSize || '12px',
                            readMoreFontWeight: htmlData?.tripadvisor?.reviews?.readMoreFontWeight || 'normal',
                            readMoreColor: htmlData?.tripadvisor?.reviews?.readMoreColor || '#00aa6c',
                            readMoreHoverColor: htmlData?.tripadvisor?.reviews?.readMoreHoverColor || '#008055',
                            tripTypeFontFamily: htmlData?.tripadvisor?.reviews?.tripTypeFontFamily || 'Arial, sans-serif',
                            tripTypeFontSize: htmlData?.tripadvisor?.reviews?.tripTypeFontSize || '12px',
                            tripTypeFontWeight: htmlData?.tripadvisor?.reviews?.tripTypeFontWeight || 'normal',
                            tripTypeColor: htmlData?.tripadvisor?.reviews?.tripTypeColor || '#666666',
                            reviewBackgroundColor: htmlData?.tripadvisor?.reviews?.reviewBackgroundColor || '#ffffff',
                            reviewBorderColor: htmlData?.tripadvisor?.reviews?.reviewBorderColor || '#e0e0e0',
                            reviewBorderRadius: htmlData?.tripadvisor?.reviews?.reviewBorderRadius || '4px',
                            reviewPadding: htmlData?.tripadvisor?.reviews?.reviewPadding || '10px',
                            reviewMinHeight: htmlData?.tripadvisor?.reviews?.reviewMinHeight || 'auto',
                            showReviewDate: htmlData?.tripadvisor?.reviews?.showReviewDate !== false,
                            showTripType: htmlData?.tripadvisor?.reviews?.showTripType !== false,
                            showReviewPhotos: htmlData?.tripadvisor?.reviews?.showReviewPhotos !== false,
                        },
                        filters: {
                            numberOfRatings: htmlData?.tripadvisor?.filters?.numberOfRatings || 'all',
                            numberOfReviews: htmlData?.tripadvisor?.filters?.numberOfReviews || 'all',
                            reviewPageCount: htmlData?.tripadvisor?.filters?.reviewPageCount || '1',
                        },
                        container: {
                            containerMaxWidth: htmlData?.tripadvisor?.container?.containerMaxWidth || '100%',
                        },
                    },
                },
                widgetType: widget.widgetType.id,
                widgetTypeName: widget.widgetType.name,
                widgetTypeScripts: widget.widgetType.scripts,
                title: widget.title || '',
                expires: widget.expires || '',
                isUrlChanged: true,
                isReviewCountChanged: false,
            },
            activeAccordion: [],
            infoPopup: React.createRef(),
        };
    }

    handleInputChange = async (e, sectionPath = []) => {
        const { type, name, value, checked } = e.target;

        await this.setState((prevState) => {
            const newState = { ...prevState };
            let targetObj = newState.widget.htmlData.tripadvisor;
            if (sectionPath.length > 0) {
                sectionPath.forEach((section) => {
                    targetObj = targetObj[section];
                });
            }

            if (name === 'title') {
                newState.widget.title = value;
            } else if (name.includes('.')) {
                const [section, field] = name.split('.');
                newState.widget.htmlData.tripadvisor[section] = {
                    ...prevState.widget.htmlData.tripadvisor[section],
                    [field]: type === 'checkbox' ? checked : value,
                };
            } else if (sectionPath.length > 0) {
                targetObj[name] = type === 'checkbox' ? checked : value;
            } else {
                newState.widget.htmlData.tripadvisor[name] = type === 'checkbox' ? checked : value;
            }
            newState.widget.isUrlChanged = name === 'url';
            newState.widget.isReviewCountChanged = name === 'filters.reviewPageCount';
            return newState;
        });

        const tripadvisorURL = this.state.widget.htmlData.tripadvisor.url;
        if (tripadvisorURL) {
            const { previewWidget } = this.props;
            await previewWidget(this.state.widget);
        }
    };

    setColorsAndPreview = async (section, field, value) => {
        await this.setState((prevState) => {
            const newState = { ...prevState };
            if (section) {
                newState.widget.htmlData.tripadvisor[section] = {
                    ...prevState.widget.htmlData.tripadvisor[section],
                    [field]: value,
                };
            } else {
                newState.widget.htmlData.tripadvisor[field] = value;
            }
            newState.widget.isUrlChanged = false;
            newState.widget.isReviewCountChanged = false;
            return newState;
        }, async () => {
            const tripadvisorURL = this.state.widget.htmlData.tripadvisor.url;
            if (tripadvisorURL) {
                const { previewWidget } = this.props;
                await previewWidget(this.state.widget);
            }
        });
    };

    toggleAccordion = (id) => {
        this.setState((prevState) => ({
            activeAccordion: prevState.activeAccordion.includes(id)
                ? prevState.activeAccordion.filter((i) => i !== id)
                : [...prevState.activeAccordion, id],
        }));
    };

    handleCompanyNameClick = () => {
        const tripadvisorURL = this.state.widget.htmlData.tripadvisor.url;
        if (tripadvisorURL) {
            window.open(tripadvisorURL, '_blank');
        }
    };

    toggleColorPicker = (e) => {
        const picker = e.target.nextElementSibling;
        picker.style.display = picker.style.display === 'none' ? 'flex' : 'none';
    };

    openFilterInfoPopup = () => {
        if (this.state.infoPopup.current) {
            this.state.infoPopup.current.openPopup();
        }
    };

    async componentDidMount() {
        const tripadvisorURL = this.state.widget.htmlData.tripadvisor.url;
        if (tripadvisorURL) {
            const { previewWidget } = this.props;
            await previewWidget(this.state.widget);
        }
    }

    renderBuilderSection = () => {
        const { title, htmlData: { tripadvisor } } = this.state.widget;

        // Placeholder content for InfoPopup
        const filterInfoContent = `
            <h2>Understanding Review Filters</h2>
            <p>The Filters section allows you to customize how reviews are displayed on your Tripadvisor widget. Below is an explanation of how each filter works:</p>

            <h3>Star Ratings</h3>
            <p>The "Star Ratings" filter lets you display reviews based on their rating. You can choose to show all reviews or filter by specific star ratings (e.g., 5 Stars, 4 Stars and up, etc.). When a star rating filter is applied, only reviews meeting the selected criteria will be displayed. For example, selecting "5 Stars" will show only reviews rated 5 stars.</p>

            <h3>Max Reviews</h3>
            <p>The "Max Reviews" filter sets the maximum number of reviews to display at one time. Options include "All Reviews" or a specific number (e.g., 5, 10, 15, or 20). This ensures that only the specified number of reviews is shown, even if more reviews are available or fetched. For instance, if you set "Max Reviews" to 20, the widget will display up to 20 reviews that match your other filter criteria.</p>

            <h3>Pages(20 Reviews)</h3>
            <p>The "Pages" filter controls how many additional reviews are fetched when needed. By default, the widget fetches an initial set of 20 reviews. If you increase this number (e.g., to 40), the widget will fetch an additional 20 reviews, adding to the existing ones. This is useful when you want to ensure a sufficient number of reviews are available, especially after applying filters like "Star Ratings."</p>

            <h3>How These Filters Work Together</h3>
            <p>Here’s an example to illustrate how these filters interact:</p>
            <ul>
                <li>Initially, the widget fetches 20 reviews based on your settings.</li>
                <li>If you apply a "Star Ratings" filter (e.g., 5 Stars) and only 15 reviews match this criterion, but you want to display 20 reviews, you can use "Pages" to fetch additional reviews.</li>
                <li>Suppose the next fetch retrieves 18 more 5-star reviews. Now, you have 15 (initial) + 18 (new) = 33 reviews. However, if "Max Reviews" is set to 20, the widget will display only the first 20 reviews from this pool, ensuring the display limit is respected.</li>
            </ul>
            <p>This combination of filters gives you precise control over which reviews are shown and how many, ensuring a tailored display of reviews on your widget.</p>
        `;

        return (
            <div className="mjwi-editor-builder">
                <label htmlFor="title">Widget Name</label>
                <input
                    type="text"
                    name="title"
                    value={title}
                    placeholder="Enter Widget Name"
                    onChange={this.handleInputChange}
                />
                <label htmlFor="url">Tripadvisor Hotel Or Restaurant URL</label>
                <input
                    type="text"
                    name="url"
                    value={tripadvisor.url}
                    placeholder="https://www.tripadvisor.in/Hotel_Review-g..."
                    onChange={this.handleInputChange}
                />
                <Accordion allowZeroExpanded>
                    <AccordionItem>
                        <AccordionItemHeading>
                            <AccordionItemButton>Header</AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                            <div className="mjwi-acc-panel-wrapper">
                                <div className="mjwi-row">
                                    <div className="mjwi-col66">
                                        <label>Header</label>
                                    </div>
                                    <div className="mjwi-col33">
                                        <ToggleSwitch
                                            name="header.showHeader"
                                            checked={tripadvisor.header.showHeader}
                                            onChange={this.handleInputChange}
                                        />
                                    </div>
                                </div>
                                {tripadvisor.header.showHeader && (
                                    <>
                                        <div className="mjwi-row">
                                            <div className="mjwi-col50">
                                                <label>Logo</label>
                                            </div>
                                            <div className="mjwi-col33">
                                                <ToggleSwitch
                                                    name="header.showLogo"
                                                    checked={tripadvisor.header.showLogo}
                                                    onChange={this.handleInputChange}
                                                />
                                            </div>
                                        </div>
                                        <div className="mjwi-row">
                                            <div className="mjwi-col50">
                                                <label>Company Name</label>
                                            </div>
                                            <div className="mjwi-col33">
                                                <ToggleSwitch
                                                    name="header.showCompanyName"
                                                    checked={tripadvisor.header.showCompanyName}
                                                    onChange={this.handleInputChange}
                                                />
                                            </div>
                                        </div>
                                        <div className="mjwi-row">
                                            <div className="mjwi-col50">
                                                <label>Total Reviews</label>
                                            </div>
                                            <div className="mjwi-col33">
                                                <ToggleSwitch
                                                    name="header.showTotalReviews"
                                                    checked={tripadvisor.header.showTotalReviews}
                                                    onChange={this.handleInputChange}
                                                />
                                            </div>
                                        </div>
                                        <div className="mjwi-row">
                                            <div className="mjwi-col50">
                                                <label>Rating</label>
                                            </div>
                                            <div className="mjwi-col33">
                                                <ToggleSwitch
                                                    name="header.showRating"
                                                    checked={tripadvisor.header.showRating}
                                                    onChange={this.handleInputChange}
                                                />
                                            </div>
                                        </div>
                                    </>
                                )}
                            </div>
                        </AccordionItemPanel>
                    </AccordionItem>
                    <AccordionItem>
                        <AccordionItemHeading>
                            <AccordionItemButton>Button</AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                            <div className="mjwi-acc-panel-wrapper">
                                <div className="mjwi-row">
                                    <div className="mjwi-col66">
                                        <label>Write a Review</label>
                                    </div>
                                    <div className="mjwi-col33">
                                        <ToggleSwitch
                                            name="button.showWriteReview"
                                            checked={tripadvisor.button.showWriteReview}
                                            onChange={this.handleInputChange}
                                        />
                                    </div>
                                </div>
                            </div>
                        </AccordionItemPanel>
                    </AccordionItem>
                    <AccordionItem>
                        <AccordionItemHeading>
                            <AccordionItemButton>Reviews</AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                            <div className="mjwi-acc-panel-wrapper">
                                <div className="mjwi-row">
                                    <div className="mjwi-col66">
                                        <label>Date</label>
                                    </div>
                                    <div className="mjwi-col33">
                                        <ToggleSwitch
                                            name="reviews.showReviewDate"
                                            checked={tripadvisor.reviews.showReviewDate}
                                            onChange={this.handleInputChange}
                                        />
                                    </div>
                                </div>
                                <div className="mjwi-row">
                                    <div className="mjwi-col66">
                                        <label>Trip Type</label>
                                    </div>
                                    <div className="mjwi-col33">
                                        <ToggleSwitch
                                            name="reviews.showTripType"
                                            checked={tripadvisor.reviews.showTripType}
                                            onChange={this.handleInputChange}
                                        />
                                    </div>
                                </div>
                                <div className="mjwi-row">
                                    <div className="mjwi-col66">
                                        <label>Review Photos</label>
                                    </div>
                                    <div className="mjwi-col33">
                                        <ToggleSwitch
                                            name="reviews.showReviewPhotos"
                                            checked={tripadvisor.reviews.showReviewPhotos}
                                            onChange={this.handleInputChange}
                                        />
                                    </div>
                                </div>
                            </div>
                        </AccordionItemPanel>
                    </AccordionItem>
                    <AccordionItem>
                        <AccordionItemHeading>
                            <AccordionItemButton>Filters
                                <i onClick={this.openFilterInfoPopup}
                                    className="fa-solid fa-circle-info"
                                    style={{ marginLeft: '5px', cursor: 'pointer' }}
                                />
                            </AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                            <div className="mjwi-acc-panel-wrapper">
                                <div className="mjwi-row">
                                    <div className="mjwi-col50">
                                        <label>Star Ratings</label>
                                    </div>
                                    <div className="mjwi-col50">
                                        <select
                                            name="filters.numberOfRatings"
                                            value={tripadvisor.filters.numberOfRatings}
                                            onChange={this.handleInputChange}
                                            className="mjwi-select"
                                        >
                                            <option value="all">All Ratings</option>
                                            <option value="5">5 Stars</option>
                                            <option value="4">4 Stars and up</option>
                                            <option value="3">3 Stars and up</option>
                                            <option value="2">2 Stars and up</option>
                                            <option value="1">1 Star and up</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="mjwi-row">
                                    <div className="mjwi-col50">
                                        <label htmlFor="filters.reviewPageCount">Pages</label>
                                    </div>
                                    <div className="mjwi-col50">
                                        <input
                                            type="number"
                                            name="filters.reviewPageCount"
                                            value={tripadvisor.filters.reviewPageCount}
                                            onChange={this.handleInputChange}
                                            min="1"
                                            max="50"
                                        />
                                    </div>
                                </div>
                                <div className="mjwi-row">
                                    <div className="mjwi-col50">
                                        <label>Max Reviews</label>
                                    </div>
                                    <div className="mjwi-col50">
                                        <select
                                            name="filters.numberOfReviews"
                                            value={tripadvisor.filters.numberOfReviews}
                                            onChange={this.handleInputChange}
                                            className="mjwi-select"
                                        >
                                            <option value="all">All Reviews</option>
                                            <option value="5">5</option>
                                            <option value="10">10</option>
                                            <option value="15">15</option>
                                            <option value="20">20</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </AccordionItemPanel>
                    </AccordionItem>
                </Accordion>
                <InfoPopup ref={this.state.infoPopup} info={filterInfoContent} />
            </div>
        );
    };

    renderLayoutSection = () => {
        const { widget, activeAccordion } = this.state;
        const { htmlData: { tripadvisor } } = widget;

        return (
            <div className="mjwi-editor-layout">
                <Accordion allowZeroExpanded preExpanded={activeAccordion}>
                    <ContainerSettings
                        tripadvisor={tripadvisor}
                        handleInputChange={this.handleInputChange}
                        setColorsAndPreview={this.setColorsAndPreview}
                        toggleColorPicker={this.toggleColorPicker}
                        renderSection={this.renderSection}
                    />
                    {tripadvisor.header.showHeader && (
                        <HeaderSettings
                            tripadvisor={tripadvisor}
                            handleInputChange={this.handleInputChange}
                            setColorsAndPreview={this.setColorsAndPreview}
                            toggleColorPicker={this.toggleColorPicker}
                            renderSection={this.renderSection}
                        />
                    )}
                    <LayoutSettings
                        tripadvisor={tripadvisor}
                        handleInputChange={this.handleInputChange}
                        setColorsAndPreview={this.setColorsAndPreview}
                        toggleColorPicker={this.toggleColorPicker}
                        renderSection={this.renderSection}
                    />
                    {tripadvisor.button.showWriteReview && (
                        <ButtonSettings
                            tripadvisor={tripadvisor}
                            handleInputChange={this.handleInputChange}
                            setColorsAndPreview={this.setColorsAndPreview}
                            toggleColorPicker={this.toggleColorPicker}
                            renderSection={this.renderSection}
                        />
                    )}
                    <ReviewsSettings
                        tripadvisor={tripadvisor}
                        handleInputChange={this.handleInputChange}
                        setColorsAndPreview={this.setColorsAndPreview}
                        toggleColorPicker={this.toggleColorPicker}
                        renderSection={this.renderSection}
                    />
                </Accordion>
            </div>
        );
    };

    renderSection = (title, children, uuid) => (
        <AccordionItem uuid={uuid}>
            <AccordionItemHeading>
                <AccordionItemButton onClick={() => this.toggleAccordion(uuid)}>
                    <span>{title}</span>
                </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel style={{ padding: '15px 5px' }}>
                {children}
            </AccordionItemPanel>
        </AccordionItem>
    );

    render() {
        const { selectedEditor } = this.props;

        return (
            <div className="mjwi-editor-main-inner">
                {selectedEditor === 'Builder' && this.renderBuilderSection()}
                {selectedEditor === 'Layout' && this.renderLayoutSection()}
            </div>
        );
    }
}

export default Tripadvisor;